module.exports = __webpack_public_path__ + "img/day-trip-flying-icon.5a58ae9c.svg";